import React from "react";

function HeroComp({ background, title }) {
  return (
    <section
      className="hero is-medium is-bold hero-comp"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="hero-body">
        <div className="container">
          <h1 className="title hero-comp-title">{title}</h1>
        </div>
      </div>
    </section>
  );
}

export default HeroComp;
